
export default function MarkSaved({ markSaved }) {
    return async ({ keys }) => {
        markSaved(keys)
    }
}